import { Fragment, ReactNode } from 'react';

export type ConditionalRendererProps = {
  condition: boolean | any;
  children: ReactNode;
  fallback?: ReactNode;
};

export default function ConditionalRenderer({
  condition,
  children,
  fallback,
}: ConditionalRendererProps) {
  if (condition) {
    return <Fragment>{children}</Fragment>;
  } else return <Fragment>{fallback}</Fragment>;
}
